import { useCallback, useEffect, useMemo, useRef } from "react";

import { defaultMST1011_R01Filter, useMST1011_R01Store } from "src/containers/mes/MST/MST1011_R01/Store_MST1011_R01";
import useUiuxStore from "src/store/useUiuxStore";

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { refetchUpdateList } from "src/utils/axios/reFetch";
import { validateString } from "src/utils/string/stringUtil";
import { showError, showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { createMST1011_R01, deleteMST1011_R01, downloadExcel_MST1011_R01, getMST1011_R01AllCount, getMST1011_R01Image, getMST1011_R01List, getMST1011_R01One, patchMST1011_R01, postMST1011_R01ItemGroupAccount } from "./Api_MST1011_R01";
import { defaultMST1011_R01Dto, MST1011_R01Dto } from "./Dto_MST1011_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from "src/utils/grid/GridHandlerContent";
import { defaultItem, ItemDto } from "src/dtos/item/itemDto";
import { validateCustomCd } from "src/utils/grid/GridValidateContent";
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	MST1011_R01_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';

interface Props {
	gridRef: React.RefObject<AgGridReact<MST1011_R01Dto> | null>;
	containerRef: React.RefObject<HTMLDivElement | null>;
	
}

export const Content_MST1011_R01 = (props: Props) => {

	const {
		gridRef,
		containerRef,
		
	} = props;

	useFetchActionbarAuth("MST1011_R01");
	const { unitList, brandCdList, itemGroupList, itemAccountList, customCdList, fetchItemCdCode } = useCommonCodeStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();

	
	const { 
		
		MST1011_R01List, setMST1011_R01List, 
		selectedMST1011_R01,  setSelectedMST1011_R01, 
		editMST1011_R01, setEditMST1011_R01, 
		allCount, setAllCount,
		initData,
		} = useMST1011_R01Store();

	const { 
		MST1011_R01Filter, setMST1011_R01Filter,
		MST1011_R01PastFilter, setMST1011_R01PastFilter,
		setScrollTop,
	 } = useMST1011_R01Store();
	const { setMessage } = useUiuxStore();
	const isResizing = useRef(true);

	const handleExcelClick = useCallback(async () => {
		setLoadingSpinner(true);

		const response = await downloadExcel_MST1011_R01(
			'',
			getParams(MST1011_R01Filter),
			MST1011_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '품목 정보등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [MST1011_R01Filter, MST1011_R01List, setLoadingSpinner]);

	const getParams = (filter: { brandCd: string, itemGroup: string, itemAccount: string, itemCd: string, itemNm: string }) => {
		const params = {
			itemBrand: filter.brandCd,
			itemGroup: filter.itemGroup,
			itemAccount: filter.itemAccount,
			itemCd: filter.itemCd,
			itemNm: filter.itemNm,
			listLength: 0
		}
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getMST1011_R01AllCount(getParams(MST1011_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [MST1011_R01Filter])

	const defaultMST1011_R01Row = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(MST1011_R01_ROW_VALIDATE, {
				brandCdList,
				itemAccountList,
				itemGroupList,
				unitList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultMST1011_R01Dto };
		}

		return {
			...defaultMST1011_R01Dto,
			brandCd: brandCdList[0].minorCd,
			itemGroup: itemGroupList[0].minorCd,
			itemAccount: itemAccountList[0].minorCd,
			itemUnit: unitList[0].minorCd,
			inserted: true,
		};
	}, [
		defaultMST1011_R01Dto, brandCdList, itemGroupList, itemAccountList, unitList,
		validateCommonCodeLists,
	]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);

		const response = await getMST1011_R01List(
			'search',
			getParams(MST1011_R01Filter),
			MST1011_R01List.length ?? 0
		);
		let newList = [...response.data.data ] as MST1011_R01Dto[];
		setMST1011_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedMST1011_R01,
				() => true,// () => !newList.find(value => value.itemCd === selectedMST1011_R01?.itemCd)
			);
			setMST1011_R01PastFilter(MST1011_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		} else {
			showWarning('조회된 데이터가 없습니다.');
			handleCreateClick();
		}
		setLoadingSpinner(false);

		return response.data.data;
	}, [MST1011_R01Filter, MST1011_R01List, gridRef, editMST1011_R01, setMST1011_R01List, setSelectedMST1011_R01, setScrollTop])

	const fetchOne = useCallback(async () => {
		if (!selectedMST1011_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getMST1011_R01One(selectedMST1011_R01.itemCd);
			setEditMST1011_R01({ ...defaultMST1011_R01Row, ...response.data.data });
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [selectedMST1011_R01]);

	const initContainerData = useCallback(() => {
		initData();
	}, [initData]);

	const handleCreateClick = useCallback(async () => {
		initItemData();
	}, []);

	const handleDeleteClick = useCallback(async () => {
		if (!selectedMST1011_R01) {
			showWarning('선택된 품목이 없습니다.'); return;
		}
		if (window.confirm('정말로 삭제하시겠습니까?')) {
			await deleteMST1011_R01(selectedMST1011_R01.itemCd);
			refetchUpdateList('delete', selectedMST1011_R01, selectedMST1011_R01, 'itemCd', MST1011_R01List, setMST1011_R01List);
			handleCreateClick();
			showSuccess(`${selectedMST1011_R01.itemCd} 품목 삭제가 완료되었습니다.`)
		}

	}, [selectedMST1011_R01])

	const validateInsertData = (data: MST1011_R01Dto, isPost: boolean) => {

		if (isPost) {
			if (!validateString(data.customCd)) {
				showWarning("거래처코드를 입력하세요."); return false;
			}
			if (!validateString(data.itemGroup)) {
				showWarning("품목그룹을 선택하세요."); return false;
			}
		}
		if (!validateString(data.itemNm)) {
			showWarning("품명을 입력하세요."); return false;
		}
		if (!validateString(data.itemSpec)) {
			showWarning("규격을 입력하세요."); return false;
		}
		if (!validateString(data.modelNo)) {
			showWarning("모델명을 입력하세요."); return false;
		}
		// if (!validateString(data.customCd)) {
		// 	showWarning("거래처코드를 입력하세요."); return false;
		// }
		// if (!validateCustomCd(data.customCd, customCdList)) {
		// 	showWarning('거래처가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		// }
		// if (!validateString(data.customItemcd)) {
		// 	showWarning("발주처 제품코드를 입력하세요."); return false;
		// }

		return true;
	}

	const handleSaveClick = useCallback(async () => {

		if (!editMST1011_R01) {
			showWarning("품목을 선택하세요."); return;
		}

		const isPost = !selectedMST1011_R01;
		if (!validateInsertData(editMST1011_R01, isPost)) return;

		let processName = '';
		let responseData: ItemDto = { ...defaultItem };
		let saveData = { ...editMST1011_R01 };
	
		if (selectedMST1011_R01) {
			processName = 'patch';
			const response = await patchMST1011_R01(saveData);
			responseData = response.data.data;
			if (response && response.data) {
				if (response.data.successFlag) {
					showSuccess(`${saveData.itemCd} 품목 수정이 완료되었습니다.`);
					setMessage(`${saveData.itemCd} 품목 수정이 완료되었습니다.`);
				}else return;
			}
		} else {
			processName = 'post';
			const generateResponse = await postMST1011_R01ItemGroupAccount(saveData);
			if (!generateResponse?.data?.successFlag || !validateString(generateResponse.data.data)) {
				showError(generateResponse?.data?.message || "품목코드 생성 중 오류가 발생했습니다.");
				return;
			}

			saveData = { ...saveData, itemCd: generateResponse.data.data };
			setEditMST1011_R01(saveData);

			const response = await createMST1011_R01(saveData);
			responseData = response.data.data;
			if (response && response.data) {
				if (response.data.successFlag) {
					showSuccess(`${saveData.itemCd} 품목 등록이 완료되었습니다.`);
					setMessage(`${saveData.itemCd} 품목 등록이 완료되었습니다.`);
				}else return;
			}
		}
	
		setTimeout(() => {
			setMessage("");
		}, 5000)
		if (saveData) {
			refetchUpdateList(processName, responseData, saveData, 'itemCd', MST1011_R01List, setMST1011_R01List);
			setSelectedMST1011_R01(responseData);
		}
		await fetchItemCdCode();

	}, [editMST1011_R01, selectedMST1011_R01])
	
	const initItemData = () => {
		setSelectedMST1011_R01(undefined);
		setEditMST1011_R01(defaultMST1011_R01Row());
	}

	//selectedMST1011_R01 변경 시 품목 이미지 불러오기
	useEffect(() => {
		if (selectedMST1011_R01) {
			fetchOne();
		}else{
			setEditMST1011_R01(defaultMST1011_R01Row());
		}
	}, [selectedMST1011_R01])

	return {
		handleExcelClick,
		defaultMST1011_R01Row,
		fetchData,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	}
}
